// import React, { useState, useEffect } from 'react'
import React, { useEffect } from 'react'
// import { Container, Button, Modal, Row, Col, Card } from 'react-bootstrap'
import { Container, Row, Col, Card } from 'react-bootstrap'
import { useSelector, useDispatch } from 'react-redux'
import { useNavigate } from 'react-router-dom'
import { getnumofRcptsOwner } from '../actions/dashboardActions.js'
// import { getMyReceipts } from '../actions/receiptActions.js'
// import { getReceiptSpendTotal } from '../actions/metaActions.js'

const OwnerDashBoard = () => {
  //   let targetdir = ''

  const dispatch = useDispatch()
  const navigate = useNavigate()

  //   const [show, setShow] = useState(false)

  //   const handleClose = () => setShow(false)
  //   const handleShow = () => setShow(true)

  //   const userLogin = useSelector((state) => state.userLogin)
  //   const { userInfo } = userLogin

  const ownerLogin = useSelector((state) => state.ownerLogin)
  const { ownerInfo } = ownerLogin

  //   if (userInfo) {
  //     const { qrfile } = userInfo
  //     targetdir = `/qrcode/${qrfile}`
  //   }

  const countRcpt = useSelector((state) => state.countRcpt)
  const { countRecpt } = countRcpt

  //   const getRcptMeta = useSelector((state) => state.getRcptMeta)
  //   const { receiptMeta } = getRcptMeta

  //   const getReceiptSpend = useSelector((state) => state.getReceiptSpend)
  //   const { receiptspend } = getReceiptSpend

  //   useEffect(() => {
  //     if (!userInfo) {
  //       navigate('/')
  //     } else {
  //       dispatch(getnumofRcpts())
  //       dispatch(getMyReceipts())
  //       dispatch(getReceiptMetainfo(userInfo._id))
  //       dispatch(getReceiptSpendTotal(userInfo._id))
  //     }
  //   }, [dispatch, navigate, userInfo])

  useEffect(() => {
    if (!ownerInfo) {
      navigate('/')
    } else {
      // navigate('/about')
      dispatch(getnumofRcptsOwner(ownerInfo.cid))
    }
  }, [dispatch, navigate, ownerInfo])

  return (
    <Container fluid>
      <Row>
        <Col className='my-2'>
          <h4>DashBoard</h4>
        </Col>
      </Row>

      <Row>
        <Col>
          <Card
            bg={'light'}
            border={'primary'}
            width={{ width: '18rem' }}
            className='mb-2'
          >
            <Card.Title className='align-center my-1 mx-1'>
              Issued Receipts
            </Card.Title>
            <Card.Body>You have {countRecpt} issued receipts.</Card.Body>
          </Card>
        </Col>
      </Row>
      {/* <Row>
        <Col>
          <Card
            bg={'light'}
            border={'primary'}
            width={{ width: '18rem' }}
            className='mb-2'
            // style={{ height: '30%' }}
          >
            <Card.Title className='my-2 mx-2'>Receipt Categories</Card.Title>
            <Card.Body>
              <ul>
                {receiptMeta &&
                  receiptMeta.map((item, index) => (
                    <Card.Text key={index}>
                      <li>
                        {item.meta}: {item.count}
                      </li>
                    </Card.Text>
                  ))}
              </ul>
            </Card.Body>
          </Card>
        </Col>
      </Row> */}
    </Container>
  )
}

export default OwnerDashBoard
